import { sectionIDs } from '../../../constants/section-ids.constants';

interface IntegrationsViewProps {
  username: string;
}

export const IntegrationsView = (props: IntegrationsViewProps) => {
  const { username } = props;
  return (
    <section id={sectionIDs.INTEGRATIONS_VIEW}>
      <p>Integrations for username: {username}</p>
    </section>
  );
};
